import { BASE_BACKEND_URL, fetchWithAuth } from '../../auth'
import { normalizeFilterSearch } from '../../helpers/utils'

export const FILTER_OPTIONS_PAGE_SIZE = 25

export const FILTER_DIMENSIONS = {
  CLIENT: 'client',
  SALESMAN: 'salesman',
  WAREHOUSE: 'warehouse'
}

export const createEmptyFilterOptionsState = () => ({
  options: [],
  page: 0,
  count: 0,
  hasMore: true,
  loading: false,
  search: ''
})

export const fetchRefundFilterOptions = async ({
  dimension,
  page = 1,
  perPage = FILTER_OPTIONS_PAGE_SIZE,
  q = '',
  signal
}) => {
  const params = new URLSearchParams({
    filter_info_only: 'true',
    filter_dimension: dimension,
    page: String(page),
    per_page: String(perPage)
  })

  const normalizedQuery = normalizeFilterSearch(q)
  if (normalizedQuery) {
    params.set('q', normalizedQuery)
  }

  const response = await fetchWithAuth(
    `${BASE_BACKEND_URL}/refunds?${params.toString()}`,
    {
      method: 'GET',
      signal
    }
  )

  if (!response) {
    return { result: [], count: 0 }
  }

  return {
    result: response.result || [],
    count: response.count || 0
  }
}
